/** When giving consent using the API (instead of customer clicking the Dialog),
 * consent can be either explicit (e.g. when clicking some custom button) or implicit. */
export var ConsentType;
(function (ConsentType) {
    ConsentType["Explicit"] = "explicit";
    ConsentType["Implicit"] = "implicit";
})(ConsentType || (ConsentType = {}));
export var UCUICMPEventType;
(function (UCUICMPEventType) {
    UCUICMPEventType["ACCEPT_ALL"] = "ACCEPT_ALL";
    UCUICMPEventType["CMP_SHOWN"] = "CMP_SHOWN";
    UCUICMPEventType["DENY_ALL"] = "DENY_ALL";
    UCUICMPEventType["IMPRINT_LINK"] = "IMPRINT_LINK";
    UCUICMPEventType["MORE_INFORMATION_LINK"] = "MORE_INFORMATION_LINK";
    UCUICMPEventType["PRIVACY_POLICY_LINK"] = "PRIVACY_POLICY_LINK";
    UCUICMPEventType["SAVE"] = "SAVE";
})(UCUICMPEventType || (UCUICMPEventType = {}));
